import { Typography } from '@mui/material';
import { Partner, PartnerOfPartner } from '@prisma/client';
import { Flex } from 'src/components/Flex';

interface LogoUploadProps {
    partner: Partner | PartnerOfPartner;
}

const LogoUpload = ({ partner }: LogoUploadProps) => {
    return (
        <Flex justifyContent={'center'} height={'fit-content'}>
            {partner.logo ? (
                <img
                    src={partner.logo}
                    alt="Partner Logo"
                    style={{ objectFit: 'contain', maxHeight: '100px', paddingBottom: '20px' }}
                />
            ) : (
                <Typography
                    sx={{ fontSize: '16px', fontWeight: 400, color: '#666', paddingBottom: '20px' }}
                >
                    No logo has been uploaded
                </Typography>
            )}
        </Flex>
    );
};
export default LogoUpload;
